

import colorPallettes from './../data/colorPallettes.json';


Array.prototype.insert = function ( index, item ) {
  this.splice( index, 0, item );
};

export const checkHexFormat = (hex) => {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test('#'+hex);
}


export const blendColors = (colorA, colorB, amount) => {
  if(typeof amount === 'undefined') amount = 0.5;
  const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
  const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
  const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
  const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
  const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
  return '#' + r + g + b;
}

export const hexToRgbA = (hex) => {

    if(checkHexFormat(hex)){
        hex = hex.split('');
        // handle 3 letters
        if(hex.length === 3){
            hex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]];
        }
        
        hex = '0x'+hex.join('');

        return {
            r: (hex>>16)&255,
            g: (hex>>8)&255,
            b: hex&255
        }
    }

    // wrong format - return white
    return {
        r: 'Is this',
        g: 'hex',
        b: 'format?'
    }
}


export const rgbToHex = (rgb) => {

    let r = rgb.r.toString(16);
    let g = rgb.g.toString(16);
    let b = rgb.b.toString(16);
  
    if (r.length === 1)
      r = "0" + r;
    if (g.length === 1)
      g = "0" + g;
    if (b.length === 1)
      b = "0" + b;
  
    return r + g + b;
}


// check similar colors
export const hexColorDelta = (hex1, hex2) => {
  // get red/green/blue int values of hex1
  let r1 = parseInt(hex1.substring(0, 2), 16);
  let g1 = parseInt(hex1.substring(2, 4), 16);
  let b1 = parseInt(hex1.substring(4, 6), 16);
  // get red/green/blue int values of hex2
  let r2 = parseInt(hex2.substring(0, 2), 16);
  let g2 = parseInt(hex2.substring(2, 4), 16);
  let b2 = parseInt(hex2.substring(4, 6), 16);
  // calculate differences between reds, greens and blues
  let r = 255 - Math.abs(r1 - r2);
  let g = 255 - Math.abs(g1 - g2);
  let b = 255 - Math.abs(b1 - b2);
  // limit differences between 0 and 1
  r /= 255;
  g /= 255;
  b /= 255;
  // 0 means opposit colors, 1 means same colors
  return (r + g + b) / 3;
}


export const invertColor = (hex) => {

  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
  }
  // invert color components
  var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
      g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
      b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
  // pad each with zeros and return
  return padZero(r) + padZero(g) + padZero(b);
}

const padZero = (str, len) => {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}


// simply open the link
export const OpenLink = (href) => {
  window.history.pushState({}, '', href);
  const navEvent = new PopStateEvent('popstate');
  window.dispatchEvent(navEvent);
}


// color pallettes

export const GetColorPallettes = () => {
  return colorPallettes.colorPallettes;
}

export const GetCloseColorPallettes = (hex) => {
  let colors = colorPallettes.colorPallettes.filter(colorPallette => {
    let close = false;
    colorPallette.colors.forEach(color => {
      if(AreColorsClose(hex,color)) close = true;
    });
    return close;
  })
  return colors;
}

export const AreColorsClose = (colA, colB) => {
  return hexColorDelta(colA,colB) > (1-2/colorPallettes.colorPallettes.length);
}



export const UpdateFavicon = (hex) => {

    //console.log(document.getElementById("favicon"));
    //document.getElementById("favicon").href = './favicons/favicon.ico';
}